import { Injectable, PLATFORM_ID, Inject, signal, computed } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { Router } from '@angular/router';

import { BehaviorSubject, Subject } from 'rxjs';

import { GlobalContants } from "../constants/global.contants";
import { StoreService } from './store.service';


@Injectable({
  providedIn: 'root'
})
export class SharedService {

  userInfo$ = new BehaviorSubject<any>(null);
  userToken$ = new BehaviorSubject<string>('');
  isBrowser: boolean;
    location: Location;
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private storeService: StoreService,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.location = window.location;
    }
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  get userInfo(): string {
    if (this.isBrowser) {
      return this.storeService.get(GlobalContants.StoreKey.userInfo)
    }
    return '';
  }

  get userToken(): string {
    if (this.isBrowser) {
      return this.storeService.get(GlobalContants.StoreKey.userToken)
    }
    return '';
  }


  getStoreValue(storykey: string): any {
    if (this.isBrowser) {
      return this.storeService.get(storykey);
    }
    return null;
  }

  setStoreValue(storykey: string, value:any): any{
    if(this.isBrowser){
      this.storeService.add(storykey, value);
    }
  }
  clearSession(storykey: string): any{
    if(this.isBrowser){
      this.storeService.clearSessionData(storykey);
    }
  }
 
  /**
   * Save user data in local storage 
   * @param record 
   */
  SaveUserInfo(record:any){
    let first_name = record.user_details && record.user_details[1] ? record.user_details[1].first_name  : '';
    let last_name = record.user_details && record.user_details[1] ? record.user_details[1].last_name : '';
    let fullName = first_name.trim() + ' ' + last_name.trim();
    record['full_name']=fullName;
    record['short_name']=fullName.split(' ').map((name: any) => name.charAt(0)).join('')?.toUpperCase()
    this.storeService.add(GlobalContants.StoreKey.userInfo, record);
    this.userInfo$.next(record.user_info);
  }

  get UserId(): any {
    let userInfo: any = this.getStoreValue(GlobalContants.StoreKey.userInfo)
    return userInfo ? userInfo.user_id : '';
  }

  getInitCharName(name: string) {
    if (name) {
      var names = name.trim().split(/\s+/);

      // Replaces the first name with an initial, followed by a period.
      names[0] = names[0].substring(0, 1) + "";
      names[1] = names[1].substring(0, 1) + "";

      // Glue the pieces back together.
      var name_abbr = names.join('');
      return name_abbr;
    }
    return '';
  }


  getDurationInSeconds(startDate: Date, EndDate: Date) {
    const diff = (EndDate.getTime() - startDate.getTime()) / 1000;
    return Math.abs(Math.round(diff));
  }

  compareObject(obj1: any, obj2: any): boolean {
    if (obj1 && obj2) {
      if (Object.keys(obj1).length == Object.keys(obj2).length) {
        var flag = true;
        for (let key in obj1) {
          if (obj1[key] == obj2[key]) {
            continue;
          } else {
            flag = false;
            break;
          }
        }
        return flag;
      }
      return false;
    }
    return false;
  }

  formatDateUTC(dt: any, getTime: boolean = false) {
    let value;
    if (dt == null) return '-';
    dt = new Date(dt);
    value = new Date(dt + ' UTC');
    if (getTime) {
      return value.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) + " " + value.getHours().toString().padStart(2) + ":"
        + value.getMinutes().toString().padStart(2) + ":" + value.getSeconds().toString().padStart(2);
    } else {
      return (
        value.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
      );
    }
  }

  
  downloadExcelUrl(file_path: string) {
    var a: any = document.createElement('A');
    a.href = file_path;
    a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  removeUnderscores(value: string) {
    if (value) {
      value = value.toString().trim();
      value = value.toLowerCase();
      let name = value.replace(/_/g, ' ');
      return this.camelizeAll(name);
    } else {
      return '';
    }
  }

  camelizeAll(str: string) {
    const arr = str.split(' ');
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const str2 = arr.join(' ');
    return str2;
  }

  scrollMenu(menu: string) {
    document.getElementById(`${menu}`)?.scrollIntoView({ behavior: "smooth" })
  }

  /**
   * This function is used to sort object based on keys.
   * @param obj : object to sort.
   * @returns : return sorted object based on keys.
   */
  sortObjectByKey(obj: any) {
    const sortedKeys = Object.keys(obj).sort();  // Sorts keys alphabetically
    const sortedObj: any = {};
    sortedKeys.forEach(key => {
      sortedObj[key] = obj[key];
    });
    return sortedObj;
  }

  safeEncode(value: string): string {
    const specialChars = /[#%&?=]/;
    if (specialChars.test(value)) {
      return encodeURIComponent(value);
    }
    return value;
  }

}
